module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted-4f83b6dd56047bb4807f74cabddd5e49.svg";